<!--NOT FINISHED, min width + truncate not working -->
<template>
    <div>
        <ul class="wrap" :id="uniqueId" v-if="options">
            <li v-for="item in shownOptions" :key="item[idField]" :class="{'withPrefix': item[prefixField]}">
                <span v-if="item.prefix" class="prefix" v-once>{{item[prefixField]}}</span>
                <span class="radius secondary label small">
                    <CountryFlag :countryCode="item[flagField]"
                                 class="country-icon"
                                 v-if="hasFlag(item)"></CountryFlag>
                    <IconBase v-if="item.icon"
                              :iconName="item.icon.name"
                              width="13"
                              height="14"
                              class="icon-pre"
                              :iconColor="item.icon.color">
                    </IconBase>
                    <Tooltip :text="item[customTooltipField] || item[displayTextField]"
                             :class="{noRemoving: (disableRemovingItems || !isItemRemovable(item)),
                                      hasFlag: hasFlag(item), 'has-icon': item.icon}" class="truncate">
                        {{item[displayTextField]}}
                    </Tooltip>
                    <span @click="emitRemoveItem(item)">
                        <IconBase icon-name="closeV2Icon"
                                  v-once
                                  class="xShape"
                                  :iconColor="consts.COLORS.LIGHT_900"
                                  width="8"
                                  height="8"
                        ></IconBase>
                    </span>
                </span>
            </li>
        </ul>
        <button type="button" class="button-linkStyle showMoreButton"
                @click="showMore"
                v-if="options.length > shownOptions.length">
            Show All
        </button>
    </div>
</template>

<script>
import Tooltip from 'components/Tooltip/Tooltip.vue';
import CountryFlag from 'components/countryFlag/countryFlag.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'SelectionTags',
    components: { IconBase, CountryFlag, Tooltip },
    props: {
        options: Array,
        flagField: {
            type: String,
            default: 'flag'
        },
        displayTextField: {
            type: String,
            default: 'text'
        },
        notRemovableField: {
            type: String,
            default: 'notRemovable'
        },
        idField: {
            type: String,
            default: 'key'
        },
        customTooltipField: {
            type: String,
            default: 'customTooltip'
        },
        prefixField: {
            type: String,
            default: 'prefix'
        },
        disableRemovingItems: {
            type: Boolean,
            default: false
        },
        maxOptionsInitial: {
            type: Number,
            default: 1000
        },
        uniqueId: String
    },
    computed: {
        shownOptions() {
            return this.options.slice(0, this.maxOptions);
        }
    },
    methods: {
        isItemRemovable(item) {
            return !item[this.notRemovableField];
        },
        showMore() {
            this.maxOptions = this.options.length;
        },
        hasFlag(item) {
            return (this.shownOptions.length < 20 && item[this.flagField]);
        },
        emitRemoveItem(item) {
            this.$emit('removeItem', item);
        }
    },
    data() {
        return {
            consts,
            maxOptions: this.maxOptionsInitial
        };
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    .wrap{
        list-style: none;
        margin: 7px 0 0 0;
        padding:0;

        li {
            display: inline-block;
            margin-right:5px;
            max-width: 250px;
            margin-bottom:7px;
            background-color: $light-300;
            color: $dark-300;
            border-radius: 100px;
            padding: 1px 10px 4px;
            user-select: none;

            .label{
                width: 100%;
                @include font(6);
                display: inline-block;
                white-space: nowrap;
                line-height: 14px;

                span{
                    vertical-align: middle;
                }
            }

            &.withPrefix{
                white-space: nowrap;
                padding-left: 0;
                padding-bottom: 0;

                &:hover{
                    padding: 1px 10px 0 0;
                    border: none;
                }

                .label {
                    width: calc(100% - 30px);
                    vertical-align: middle;
                    padding-bottom: 4px;
                    padding-top: 4px;
                    margin-left: -4px;
                }
            }
        }
        .xShape{
            cursor:pointer;
            margin-left: 5px;
            margin-right: 0;
        }
        .truncate{
            max-width: calc(100% - 10px);

            &.hasFlag, &.has-icon {
                max-width: calc(100% - 32px);
            }

            &.noRemoving{
                max-width: 100%;
            }
        }
    }

    .prefix {
        @include font(6);;
        color: $white;
        background-color: $light-900;
        border-bottom-left-radius: 100px;
        border-top-left-radius: 100px;
        height: 24px;
        width: 30px;
        padding-left: 13px;
        padding-top: 6px;
        display: inline-block;
        vertical-align: middle;
    }

    .showMoreButton {
        padding: 0;
        height: 18px;
    }
    .country-icon {
        margin-right: 7px;
    }

    .icon-pre {
        margin-right: 7px;
    }
</style>
